export default __webpack_public_path__ + "static/media/tip10.b72eac25.png";